import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seoArticles';

export default function BlogPreview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" id="blog">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <span className="text-xs font-medium text-foreground-500 tracking-widest uppercase">
            / Latest Guides
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-3 leading-[1.15]">
            <span className="block font-bold">SEO Sourcing</span>
            <span className="block italic font-normal text-foreground-700">Guides &amp; Articles</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl">
            Expert articles about the itaobuyspreadsheet system. Learn strategies, tips, and best practices for smarter product sourcing.
          </p>
        </div>

        {/* Featured Article - First one */}
        <div className="mb-8">
          <Link
            to={`/guide/${seoArticles[0].slug}`}
            className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300 smooth-transition cursor-pointer flex flex-col lg:flex-row"
          >
            <div className="lg:w-1/2 aspect-[16/9] lg:aspect-auto bg-secondary-100 relative overflow-hidden">
              <img
                src={seoArticles[0].cardImageUrl}
                alt={seoArticles[0].title}
                title={seoArticles[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="lg:w-1/2 p-6 md:p-8 flex flex-col justify-center">
              <span className="text-xs text-accent-500 font-semibold uppercase tracking-wider mb-2">Featured Guide</span>
              <span className="text-xs text-foreground-500 mb-2">{seoArticles[0].date}</span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 smooth-transition">
                {seoArticles[0].title}
              </h3>
              <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                {seoArticles[0].excerpt}
              </p>
              <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600 group-hover:text-primary-700 smooth-transition">
                Read Full Article
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        </div>

        {/* Remaining Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.slice(1).map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300 smooth-transition cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] bg-secondary-100 relative overflow-hidden">
                <img
                  src={article.cardImageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs text-foreground-500 mb-2">{article.date}</span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 smooth-transition line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-xs font-medium text-primary-600 group-hover:text-primary-700 smooth-transition">
                  Read Article
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}